import React from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  FormGroup,
  Form,
  Input,
  Button,
} from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { actionSubmitExtRef } from 'store/actions/usersActions';

/**
 * @component PatientExtRefForm
 * @description Form for editing the external references of a patient's associated
 * practices. Since `associated_details` is no longer included in the Redux list
 * payload, this component fetches the full details on mount via
 * `patientService.getPatientDetails` and renders the ext-ref inputs once loaded.
 */
const PatientExtRefForm = ({ userData, practices }) => {
  const dispatch = useDispatch();
  
  const { register, handleSubmit } = useForm();
  const history = useHistory();


  /**
   * Reduces flat form fields into an array of `{ practice, ext_ref }` objects
   * and dispatches the update action.
   *
   * @param {Object} data - react-hook-form collected values.
   */
  const onSubmit = (data) => {
    const refinedData = Object.entries(data).reduce((acc, [k, v]) => {
      const parts = k.split('_');
      const id = parts[parts.length - 1];
      const keyvalue = parts.slice(0, parts.length - 1).join('_');
      (acc[id] = acc[id] || {})[keyvalue] = v;
      return acc;
    }, []);

    dispatch(actionSubmitExtRef({ ...userData, set_ext_refs: refinedData }));
  };

  return (
    <Card>
        <CardHeader>
            {`${userData?.firstName} ${userData?.lastName} External Reference edition form`}
        </CardHeader>
        <CardBody>
            <Form id="ext-ref-edit-form" onSubmit={handleSubmit(onSubmit)}>
                {practices.map((p, i) => (
                <React.Fragment key={i}>
                    <Label>External Reference ({p.name || p.practice_name || `Practice ${i + 1}`})</Label>
                    <FormGroup>
                    <Input
                        type="text"
                        name={`ext_ref_${i}`}
                        defaultValue={p.patient_ext_ref}
                        required
                        innerRef={register}
                    />
                    <Input
                        type="hidden"
                        name={`practice_${i}`}
                        defaultValue={p.practiceId} // Cambio clave: 'practiceId' en lugar de 'practice_id'
                        innerRef={register}
                    />
                    </FormGroup>
                </React.Fragment>
                ))}
            </Form>

            <Button form="ext-ref-edit-form" size="sm" color="info" type="submit">
                Update
            </Button>

            <Button
                size="sm"
                color="danger"
                onClick={(e) => {
                    e.preventDefault();
                    history.goBack();
                }}
            >
                Cancel
            </Button>
        </CardBody>
    </Card>
  );
};

export default PatientExtRefForm;